import { Box, Container, Grid, Typography } from "@material-ui/core";
import { useOktaAuth } from "@okta/okta-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./index.css";
import config from "./config.json";

function IndexLandingPage({ page }) {
    const today = new Date();
    const curHr = today.getHours();
    let greetings = "";
    if (curHr < 12) {
        greetings = "Good Morning";
    } else if (curHr < 18) {
        greetings = "Good Afternoon";
    } else {
        greetings = "Good Evening";
    }

    const { authState, oktaAuth } = useOktaAuth();
    const [userApps, setUserApps] = useState();

    useEffect(() => {
        if (authState && authState.isAuthenticated) {
            getUserPermissions();
        }
    }, [authState, oktaAuth]);

    const getUserPermissions = async () => {
        const getUrl = `${process.env.REACT_APP_AUTH_MANAGER_URL}/api/v1/employee/oauth/${authState?.idToken?.claims?.sub}`;
        const response = await fetch(getUrl, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
            },
        });
        const responseJson = await response.json();
        const permissions = responseJson?.data?.role?.permissions;
        setUserApps(permissions.map((a) => a.application));
    };

    return (
        <>
            <Box display="flex" flexGrow={1}>
                <Container
                    maxWidth="xl"
                    style={{
                        display: "flex",
                        flexGrow: 1,
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "0 50px",
                    }}
                >
                    <Box
                        display="flex"
                        flexGrow={1}
                        alignSelf="stretch"
                        alignItems="center"
                        justifyContent="center"
                        flexDirection="column"
                        style={{ overflow: "hidden" }}
                    >
                        <Typography
                            variant="h4"
                            component="h4"
                            style={{
                                marginBottom: "15px",
                                textTransform: "capitalize",
                                fontFamily: "GTAmericaBold",
                                fontWeight: "bold",
                            }}
                        >
                            {greetings}
                            {authState &&
                                ", " + authState?.idToken?.claims?.name}
                        </Typography>
                        <Typography
                            variant="body1"
                            component="p"
                            style={{ marginBottom: "60px" }}
                        >
                            What would you like to do today?
                        </Typography>
                        <div className="grid-container">
                            {config[page]?.length &&
                                config[page]
                                    .filter(
                                        (item) =>
                                            item.skipAuth ||
                                            userApps?.includes(item.appName),
                                    )
                                    .map((item) => {
                                        return (
                                            <Link
                                                to={item.linkTo}
                                                className="grid-item-link"
                                                target={"_blank"}
                                            >
                                                <Box
                                                    className="grid-item"
                                                    justifyContent="start"
                                                >
                                                    <IconComponent
                                                        icon={item.icon}
                                                    />
                                                    <Typography
                                                        className="grid-item-title"
                                                        variant="h6"
                                                        component="h6"
                                                    >
                                                        {item.title}
                                                    </Typography>
                                                    <Typography
                                                        variant="body1"
                                                        component="p"
                                                        style={{
                                                            marginBottom: "0px",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        {item.description}
                                                    </Typography>
                                                </Box>
                                            </Link>
                                        );
                                    })}
                        </div>
                    </Box>
                </Container>
            </Box>
        </>
    );
}

const IconComponent = ({ icon }) => {
    const icons = {
        edit: (
            <Box className="grid-item-icon-bg">
                <svg
                    className="grid-item-icon"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7.56534 30.6157L8.53363 30.8577L7.56534 30.6157C7.56254 30.6269 7.55962 30.6385 7.5566 30.6505C7.51978 30.797 7.46878 30.9999 7.45121 31.1795C7.43099 31.3862 7.42431 31.8382 7.79308 32.207L8.50019 31.4999L7.79309 32.207C8.16186 32.5757 8.61382 32.5691 8.82051 32.5488C9.00013 32.5313 9.20306 32.4803 9.34955 32.4434C9.36154 32.4404 9.37316 32.4375 9.38436 32.4347L14.7051 31.1045C14.7231 31.1 14.7415 31.0955 14.7605 31.0908C14.9688 31.0394 15.2324 30.9743 15.4742 30.8374C15.716 30.7005 15.9074 30.5079 16.0587 30.3557C16.0724 30.3419 16.0858 30.3285 16.0989 30.3154L29.2929 17.1213L29.3314 17.0829C29.6313 16.7831 29.9228 16.4917 30.1308 16.219C30.3654 15.9116 30.5858 15.5137 30.5858 15C30.5858 14.4863 30.3654 14.0884 30.1308 13.781C29.9228 13.5083 29.6314 13.217 29.3314 12.9172L29.2929 12.8787L27.1214 10.7071L27.0829 10.6686C26.7831 10.3687 26.4917 10.0772 26.2191 9.86919C25.9117 9.63466 25.5137 9.41421 25 9.41421C24.4864 9.41421 24.0884 9.63466 23.781 9.86919C23.5084 10.0772 23.217 10.3687 22.9172 10.6686C22.9044 10.6814 22.8916 10.6943 22.8787 10.7071L9.68465 23.9012C9.67158 23.9143 9.6581 23.9276 9.64428 23.9414C9.49211 24.0926 9.29949 24.2841 9.16261 24.5258L10.0299 25.0169L9.1626 24.5259C9.02572 24.7676 8.96065 25.0313 8.90925 25.2396C8.90458 25.2585 8.90003 25.277 8.89554 25.2949L7.56534 30.6157Z"
                        stroke="black"
                        strokeWidth="2"
                    />
                    <path
                        d="M21 13L25.5 9.5L30.5 14.5L27 19L21 13Z"
                        fill="black"
                    />
                </svg>
            </Box>
        ),
        home: (
            <Box className="grid-item-icon-bg">
                <svg
                    className="grid-item-icon"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8 20.014C8 17.751 8 16.6196 8.45744 15.625C8.91487 14.6304 9.77394 13.8941 11.4921 12.4214L13.1588 10.9928C16.2643 8.33094 17.817 7 19.6667 7C21.5163 7 23.0691 8.33094 26.1746 10.9928L27.8412 12.4214C29.5594 13.8941 30.4185 14.6304 30.8759 15.625C31.3333 16.6196 31.3333 17.751 31.3333 20.014V27.0813C31.3333 30.224 31.3333 31.7953 30.357 32.7716C29.3807 33.7479 27.8094 33.7479 24.6667 33.7479H14.6667C11.524 33.7479 9.95262 33.7479 8.97631 32.7716C8 31.7953 8 30.224 8 27.0813V20.014Z"
                        stroke="black"
                        strokeWidth="2"
                    />
                    <path
                        d="M23.8333 33.748V24.748C23.8333 24.1958 23.3856 23.748 22.8333 23.748H16.5C15.9477 23.748 15.5 24.1958 15.5 24.748V33.748"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        ),
        document: (
            <Box className="grid-item-icon-bg">
                <svg
                    className="grid-item-icon"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M25.5 7.33398C27.8408 7.33398 29.0112 7.33398 29.8519 7.89575C30.2159 8.13895 30.5284 8.45145 30.7716 8.81542C31.3333 9.65616 31.3333 10.8265 31.3333 13.1673V29.0007C31.3333 32.1433 31.3333 33.7147 30.357 34.691C29.3807 35.6673 27.8094 35.6673 24.6667 35.6673H14.6667C11.524 35.6673 9.95262 35.6673 8.97631 34.691C8 33.7147 8 32.1433 8 29.0007V13.1673C8 10.8265 8 9.65616 8.56177 8.81542C8.80496 8.45145 9.11747 8.13895 9.48143 7.89575C10.3222 7.33398 11.4926 7.33398 13.8333 7.33398"
                        stroke="black"
                        strokeWidth="2"
                    />
                    <path
                        d="M14.6665 7.33333C14.6665 5.49238 16.1589 4 17.9998 4H21.3332C23.1741 4 24.6665 5.49238 24.6665 7.33333C24.6665 9.17428 23.1741 10.6667 21.3332 10.6667H17.9998C16.1589 10.6667 14.6665 9.17428 14.6665 7.33333Z"
                        stroke="black"
                        strokeWidth="2"
                    />
                    <path
                        d="M14.6665 19L24.6665 19"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    <path
                        d="M14.6665 25.666L21.3332 25.666"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                </svg>
            </Box>
        ),
    };

    return icons[icon];
};

export default IndexLandingPage;
